export enum TelemetryType {
  Telemetry = "Telemetry",
  Property = "Property",
  CloudProperty = "CloudProperty",
  Command = "Command",
  Array = "Array",
  Object = "Object"
}
